import { render, staticRenderFns } from "./TemplatesNavigation.vue?vue&type=template&id=d6f6ed3c&scoped=true&"
import script from "./TemplatesNavigation.vue?vue&type=script&lang=js&"
export * from "./TemplatesNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesNavigation.vue?vue&type=style&index=0&id=d6f6ed3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f6ed3c",
  null
  
)

export default component.exports